import { cva } from "class-variance-authority";

export const searchWrapperCva = cva("inline-flex shrink-0", {
  variants: {
    hasMargin: {
      true: "mr-[15px]",
      false: null,
    },
  },
});

export const searchControlCva = cva(
  [
    "relative flex items-center h-8 overflow-hidden rounded-full text-sm border border-solid",
    "bg-(--input-background) text-gray-800 dark:text-gray-50",
    "transition-[width,border-color] duration-200",
    "ease-[cubic-bezier(0.2,0,0,1)]",
    "motion-reduce:transition-none",
    "focus-within:outline-hidden",
  ],
  {
    variants: {
      expanded: {
        true: "w-56",
        false: "w-8",
      },
      active: {
        true: "border-primary-500",
        false: "border-(--input-border) focus-within:border-primary-500",
      },
      expandedCursor: {
        true: "cursor-text",
        false: "cursor-pointer",
      },
    },
  },
);
